import { render, staticRenderFns } from "./Credentials.vue?vue&type=template&id=0bc2eb36&"
import script from "./Credentials.vue?vue&type=script&lang=ts&"
export * from "./Credentials.vue?vue&type=script&lang=ts&"
import style0 from "./Credentials.vue?vue&type=style&index=0&id=0bc2eb36&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports